/**
 * Provides the logic used by the actPaginator directive for various paging operations
 */
export class PaginatorController {
  public static $inject = ['$scope'];
  public pageStart: number;
  public pageEnd: number;
  public perPageQuantities: Array<number>;
  public paginationData: InterACT.Interfaces.IPaginationData;
  public totalPagesCount: number;
  public perPage: number;
  public totalCount: number;
  public fetchCollection: Function;
  public showExport: boolean;
  public exportHandler: Function;
  public exportFormats: Array<string>;

  constructor(private $scope) {
    this.activate();
  }

  /**
   * Determines the total number of pages based on the values assigned to the totalCount and perPage controller properties
   */
  public setTotalPages = () => {
    let total;
    if (this.totalCount % this.perPage !== 0) {
      total = Math.floor(this.totalCount / this.perPage) + 1;
    } else {
      total = this.totalCount / this.perPage;
    }
    this.totalPagesCount = total;
  }

  /**
   * Calls the function bound to the directive's fetchCollection scope property. This function will then handle the promise returned from the fetchCollection call and if successful updates the totalPagesCount, pageStart and pageEnd scope property values;
   *
   * @param page The page number to be requested from the backend service
   * @param perPage The number of items per page that the dataset should be limited to
   */
  public goToPage = (page: number, perPage: number) => {
    if (!page) {
      return;
    }

    const promise = this.fetchCollection({ page: page, perPage: perPage });

    const callback = () => {
      this.paginationData.currentPage = page;

      if (angular.isDefined(perPage)) {
        this.perPage = perPage;
      }

      this.setTotalPages();
      this.setPageBounds();
    };

    if (promise && promise.then) {
      promise.then(() => {
        callback();
      });
    } else {
      callback();
    }
  }

  /**
   * Sets the directive's controller pageStart and pageEnd properties for display purposes in the associated view template
   */
  public setPageBounds = () => {
    this.paginationData.currentPage = this.paginationData && this.totalCount > this.perPage ? this.paginationData.currentPage : 1;
    this.pageStart = (this.paginationData.currentPage - 1) * this.perPage + 1;
    this.pageEnd = this.pageStart + this.perPage - 1;

    if (this.pageEnd > this.totalCount) {
      this.pageEnd = this.totalCount;
    }
  }

  /**
   * Wraps a call to the directives scope exportHandler property
   *
   * @param format The format we want to export in
   */
  public exportAsFormat = (format: string) => {
    this.exportHandler({ type: format });
  };

  /**
   * Tells the dom if the table is exportable
   *
   * @returns true if showExport is true and if totalCount is positive
   */
  public isExportable = () => {
    return this.showExport && this.totalCount > 0;
  }

  /**
   * Runs on activation of the controller, sets up initial data and watches
   */
  private activate() {
    this.pageStart = undefined;
    this.pageEnd = undefined;
    this.perPageQuantities = [15, 30, 45, 60];

    setTimeout(() => {
      this.showExport = angular.isDefined(this.exportFormats);
    }, 1000);

    if (angular.isUndefined(this.paginationData)) {
      this.paginationData = {
        currentPage: 1
      };
    }

    this.totalPagesCount = 0;

    this.$scope.$watch('vm.totalCount', () => {
      this.setPageBounds();
      this.setTotalPages();
    });

    this.$scope.$watch('vm.paginationData.currentPage', () => {
      this.setPageBounds();
      this.setTotalPages();
    });
  }
}